<template>
  <div>
    <el-dialog
      :visible="true"
      width="25%"
      class="chartDia"
      :show-close="false"
      @close="close"
    >
      <div slot="title" class="slotTit">确认支付</div>
      <div style="margin-bottom:30px;">
        已下发短信验证码至您的手机：{{ user.transactorPhone | transPhone }}
      </div>
      <div class="flexBox" style="justify-content:center;">
        <el-input
          placeholder="请输入验证码"
          style="width:200px;margin-right:10px;"
          v-model="verifyCode"
        ></el-input>
        <el-button
          @click="sendSms"
          :loading="btnLoading"
          style="border:1px solid rgba(25,137,250,1);color:#1989FA"
          :disabled="msgTxt != '发送验证码'"
        >
          {{ msgTxt }}
        </el-button>
      </div>
      <div class="flexBox" style="justify-content:center;margin-top:24px;">
        <el-button
          style="background:rgba(198,203,212,1);color:#fff;margin-right:120px;"
          @click="close"
        >
          返回
        </el-button>
        <el-button type="primary" @click="confirm" :loading="btLoading">
          确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  sendOrderPayMsg,
  submitPayOrder,
  bfAccount,
  payPlatformService
} from '@/api/ajax';
import { btLoading } from '@/Mixin/btLoading';
export default {
  inject: ['itemData'],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number
    }
  },
  mixins: [btLoading],
  data() {
    return {
      user: {
        transactorPhone: ''
      },
      feiyongList: [
        { label: '合同签约费', key: 1 },
        { label: '实名认证费', key: 2 }
      ],
      showDetail: false,
      key: 'baofu',
      verifyCode: '',
      msgTxt: '发送验证码',
      timer: null,
      btnLoading: false
    };
  },
  methods: {
    async sendSms() {
      if (this.msgTxt == '发送验证码') {
        try {
          this.btnLoading = true;
          await sendOrderPayMsg({ csoOrderId: this.itemData.data.id });
          this.btnLoading = false;
          this.msgTxt = 60;
          this.timer = setInterval(() => {
            if (this.msgTxt > 0) {
              this.msgTxt--;
            } else {
              this.msgTxt = '发送验证码';
              clearInterval(this.timer);
            }
          }, 1000);
        } catch (error) {
          this.btnLoading = false;
          this.msgTxt = '发送验证码';
        }
      }
    },
    close() {
      this.$parent.componentName = '';
    },

    async confirm() {
      await this.SET_BTLOADING(true);
      if (this.type != 2) {
        try {
          await submitPayOrder({
            csoOrderId: this.itemData.data.id,
            verifyCode: this.verifyCode
          });
          this.$message({
            message: '已提交',
            type: 'success'
          });
          this.$parent.$parent.componentName = '';
          this.$parent.$parent.getPageList(1);
          this.SET_BTLOADING(false);
        } catch (error) {
          this.SET_BTLOADING(false);
        }
      } else {
        try {
          await payPlatformService({
            csoOrderId: this.itemData.data.id,
            serviceOrderId: this.itemData.data.serviceOrderId,
            verifyCode: this.verifyCode
          });
          this.$message({
            message: '已提交',
            type: 'success'
          });
          this.$parent.$parent.componentName = '';
          this.$parent.$parent.getPageList(1);
          this.SET_BTLOADING(false);
        } catch (error) {
          this.SET_BTLOADING(false);
        }
      }

      this.$parent.componentName = '';
      this.$parent.payType = 2;
    }
  },
  async created() {
    let {
      data: { data }
    } = await bfAccount();
    this.user = data;
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
<style lang="scss" scoped>
.flexBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 45px;
}
.colorBf {
  color: #bfbfbf;
}
.hint {
  color: #bfbfbf;
  font-size: 12px;
  margin-bottom: 16px;
}
.accountType {
  width: 138px;
}
.chargeBtn {
  width: 92px;
  height: 36px;
  background: rgba(235, 142, 14, 1);
  border-radius: 4px;
  color: #fff;
  font-size: 16px;
  line-height: 36px;
  padding: 0;
}
</style>
